var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.861,
    height: 48.861,
    viewBox: "0 0 48.861 48.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20253a;}.b{fill:#2eb77d;}.c{fill:#00bcd4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.226,27.417A1.527,1.527,0,0,1,1.7,25.963L1.092,13.28a1.527,1.527,0,0,1,3.05-.147l.611,12.683a1.524,1.524,0,0,1-1.452,1.6Z",
    transform: "translate(1.129 12.099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.7,20.414a1.526,1.526,0,0,1-1.376-2.178L8.313,3.475a1.526,1.526,0,1,1,2.759,1.307L4.087,19.542a1.531,1.531,0,0,1-1.382.871Z",
    transform: "translate(1.223 2.694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.576,5.146l-.073,0L8.2,4.371a1.529,1.529,0,0,1-1.454-1.6,1.59,1.59,0,0,1,1.6-1.452l16.307.774a1.527,1.527,0,0,1-.069,3.052Z",
    transform: "translate(6.982 1.368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.268,18.694a1.532,1.532,0,0,1-1.285-.7L16.534,4.948A1.528,1.528,0,0,1,19.1,3.287l8.449,13.05a1.527,1.527,0,0,1-.454,2.111A1.5,1.5,0,0,1,26.268,18.694Z",
    transform: "translate(16.875 2.682)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.379,27.029l-.332-.037a1.528,1.528,0,0,1-1.16-1.822l2.708-12.236a1.528,1.528,0,0,1,2.983.662L22.869,25.832A1.531,1.531,0,0,1,21.379,27.029Z",
    transform: "translate(20.562 12.161)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.275,24.047A1.527,1.527,0,0,1,6.2,20.995l26.466-1.3a1.527,1.527,0,0,1,.151,3.05l-26.466,1.3Z",
    transform: "translate(4.92 20.396)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.762,25.289a1.515,1.515,0,0,1-1.079-.448l-7.655-7.655a1.527,1.527,0,1,1,2.16-2.16l7.655,7.655a1.528,1.528,0,0,1-1.081,2.608Z",
    transform: "translate(15.103 15.102)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.224,14.857a1.527,1.527,0,0,1-.238-3.035L25.27,10.5a1.528,1.528,0,0,1,.48,3.017l-8.284,1.323Z",
    transform: "translate(16.264 10.856)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.757,16.648a1.507,1.507,0,0,1-.568-.11,1.527,1.527,0,0,1-.849-1.987L17.715,3.638a1.528,1.528,0,1,1,2.836,1.138L16.176,15.689A1.529,1.529,0,0,1,14.757,16.648Z",
    transform: "translate(13.704 2.775)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.918,17.443a1.529,1.529,0,0,1-1.3-.723L6.268,4.851a1.527,1.527,0,1,1,2.6-1.608l7.349,11.869a1.529,1.529,0,0,1-.495,2.1,1.507,1.507,0,0,1-.8.228Z",
    transform: "translate(6.257 2.61)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.544,15.014l-.14-.006L3.13,13.888a1.527,1.527,0,1,1,.277-3.042l12.274,1.12a1.527,1.527,0,0,1-.136,3.048Z",
    transform: "translate(1.803 11.229)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.429,25.194a1.526,1.526,0,0,1-.873-2.779l10.607-7.39a1.527,1.527,0,1,1,1.745,2.506L6.3,24.921a1.535,1.535,0,0,1-.871.273Z",
    transform: "translate(4.04 15.279)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.161,26.323a9.161,9.161,0,1,1,9.161-9.161A9.173,9.173,0,0,1,17.161,26.323Z",
    transform: "translate(8.287 8.287)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.108,30.215a6.108,6.108,0,1,1,6.108-6.108A6.115,6.115,0,0,1,6.108,30.215Z",
    transform: "translate(0 18.646)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.09,28.179a5.09,5.09,0,1,1,5.09-5.09A5.1,5.1,0,0,1,23.09,28.179Z",
    transform: "translate(18.646 18.646)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.108,13.054A3.054,3.054,0,1,1,3.054,10,3.054,3.054,0,0,1,6.108,13.054Z",
    transform: "translate(0 10.359)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.072,8.143a4.072,4.072,0,1,1,4.072-4.072A4.076,4.076,0,0,1,8.072,8.143Z",
    transform: "translate(4.143)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.108,4.054A3.054,3.054,0,1,1,18.054,1,3.054,3.054,0,0,1,21.108,4.054Z",
    transform: "translate(15.538 1.036)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.072,17.143a4.072,4.072,0,1,1,4.072-4.072A4.076,4.076,0,0,1,24.072,17.143Z",
    transform: "translate(20.717 9.323)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.b23a611b04799849efeeca9d4f00023b.svg";
export { ForwardRef as ReactComponent };